import React, { useEffect, useState } from 'react';
import { API_URL, ENDPOINTS } from '../../../constants/api';
import { decodeToken, getToken } from '../../../utils/TokenUtils';
import axios from 'axios';

const BalanceSheet = () => {
  // State to store income data fetched from the API
  const [balanceSheetData, setBalanceSheetData] = useState([]);
  const [loading, setLoading] = useState(true); // To show loading state
  const [error, setError] = useState(null); // For handling errors
  const token = getToken();
  const companyBanner = decodeToken(token, 'banner');
  console.log(companyBanner);
  // Get the current date
  const currentDate = new Date().toLocaleDateString();

  // Company name (You can replace this with your actual company name)
  const companyName = decodeToken(token, 'companyName');
  // Fetch data from the API on component mount
  const url = `${API_URL}/${ENDPOINTS.SYS}/getlink/balance-sheet`;
  console.log(url);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        console.log(response);
        // Assuming the API returns an array of objects with "Account" and "Amount" keys
        setBalanceSheetData(response.data.report);
        setLoading(false); // Data fetched, stop loading
      } catch (err) {
        console.log(url, err);
        setError('Failed to fetch data');
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty array means it runs once on component mount

  // Render a loading message while fetching
  if (loading) {
    return <div>Loading...</div>;
  }

  // Handle errors
  if (error) {
    return <div>{error}</div>;
  }

  // Helper function to remove dollar sign and convert to number
  const parseAmount = (amount) => {
    if (typeof amount === 'string') {
      return parseFloat(amount.replace(/[^0-9.-]+/g, '')); // Remove any non-numeric characters
    }
    return amount;
  };

  // Group the data by AccountType
  const currentAssetsData = balanceSheetData.filter(
    (item) =>
      item.AccountType === 'Main' || item.AccountType === 'SubCurrentAssets'
  );
  const fixedAssetsData = balanceSheetData.filter(
    (item) =>
      item.AccountType === 'Main' || item.AccountType === 'SubFixedAssets'
  );
  const liabilitiesData = balanceSheetData.filter(
    (item) =>
      item.AccountType === 'Main' || item.AccountType === 'SubLiabilities'
  );
  const equityData = balanceSheetData.filter(
    (item) => item.AccountType === 'Main' || item.AccountType === 'SubEquity'
  );

  // Calculate TotalCurrentAssets, TotalFixedAssets, TotalLiabilities, and TotalEquity
  const totalCurrentAssets = currentAssetsData.reduce((total, item) => {
    return total + (parseAmount(item.Amount) || 0); // Summing up the amounts without dollar sign
  }, 0);

  const totalFixedAssets = fixedAssetsData.reduce((total, item) => {
    return total + (parseAmount(item.Amount) || 0); // Summing up the amounts without dollar sign
  }, 0);

  const totalLiabilities = liabilitiesData.reduce((total, item) => {
    return total + (parseAmount(item.Amount) || 0); // Summing up the amounts without dollar sign
  }, 0);

  const totalEquity = equityData.reduce((total, item) => {
    return total + (parseAmount(item.Amount) || 0); // Summing up the amounts without dollar sign
  }, 0);

  // Helper function to format amounts with dollar sign
  const formatAmount = (amount) => {
    return `$${amount.toLocaleString()}`; // Adding $ sign back when displaying the amount
  };

  return (
    <div style={styles.container}>
      {/* Company Name and Date Section */}
      <div style={styles.headerSection}>
        <header style={styles.bannerHeader}>
          <img
            src={`${API_URL}/${companyBanner}`}
            alt="Company Banner"
            style={styles.logo}
          />
        </header>
        <h1 style={styles.companyName}>{companyName}</h1>
        <p style={styles.date}>Balance Sheet as of {currentDate}</p>
      </div>

      <table style={styles.table}>
        {/* <thead>
          <tr>
            <th style={styles.header}>Account</th>
            <th style={styles.header}>Amount ($)</th>
          </tr>
        </thead> */}
        <tbody>
          <tr>
            <td colSpan="2" style={styles.mainAccount}>
              Current Assets
            </td>
          </tr>
          {currentAssetsData.map((item, index) => (
            <tr
              key={index}
              style={
                item.AccountType === 'SubCurrentAssets'
                  ? styles.subAccountRow
                  : {}
              }
            >
              <td
                style={
                  item.AccountType === 'SubCurrentAssets'
                    ? styles.subAccountLabel
                    : styles.rowLabel
                }
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.Account}
              </td>
              <td style={styles.rowAmount}>
                {formatAmount(parseAmount(item.Amount))}
              </td>
            </tr>
          ))}
          <tr>
            <td style={styles.totalLabel}>Total Current Assets</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalCurrentAssets)}
            </td>
          </tr>

          <tr>
            <td colSpan="2" style={styles.mainAccount}>
              Fixed Assets
            </td>
          </tr>
          {fixedAssetsData.map((item, index) => (
            <tr
              key={index}
              style={
                item.AccountType === 'SubFixedAssets'
                  ? styles.subAccountRow
                  : {}
              }
            >
              <td
                style={
                  item.AccountType === 'SubFixedAssets'
                    ? styles.subAccountLabel
                    : styles.rowLabel
                }
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.Account}
              </td>
              <td style={styles.rowAmount}>
                {formatAmount(parseAmount(item.Amount))}
              </td>
            </tr>
          ))}
          <tr>
            <td style={styles.totalLabel}>Total Fixed Assets</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalFixedAssets)}
            </td>
          </tr>
          <tr>
            <td style={styles.totalLabel}>Total Assets</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalFixedAssets + totalCurrentAssets)}
            </td>
          </tr>

          <tr>
            <td colSpan="2" style={styles.mainAccount}>
              Liabilities
            </td>
          </tr>
          {liabilitiesData.map((item, index) => (
            <tr
              key={index}
              style={
                item.AccountType === 'SubLiabilities'
                  ? styles.subAccountRow
                  : {}
              }
            >
              <td
                style={
                  item.AccountType === 'SubLiabilities'
                    ? styles.subAccountLabel
                    : styles.rowLabel
                }
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.Account}
              </td>
              <td style={styles.rowAmount}>
                {formatAmount(parseAmount(item.Amount))}
              </td>
            </tr>
          ))}
          <tr>
            <td style={styles.totalLabel}>Total Liabilities</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalLiabilities)}
            </td>
          </tr>

          <tr>
            <td colSpan="2" style={styles.mainAccount}>
              Equity
            </td>
          </tr>
          {equityData.map((item, index) => (
            <tr
              key={index}
              style={
                item.AccountType === 'SubEquity' ? styles.subAccountRow : {}
              }
            >
              <td
                style={
                  item.AccountType === 'SubEquity'
                    ? styles.subAccountLabel
                    : styles.rowLabel
                }
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.Account}
              </td>
              <td style={styles.rowAmount}>
                {formatAmount(parseAmount(item.Amount))}
              </td>
            </tr>
          ))}
          <tr>
            <td style={styles.totalLabel}>Total Equity</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalEquity)}
            </td>
          </tr>
          <tr>
            <td style={styles.totalLabel}>Total Liabilities & Equity</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalEquity + totalLiabilities)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const styles = {
  container: {
    width: '80%',
    margin: 'auto',
    paddingTop: '20px',
  },
  headerSection: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  bannerHeader: {
    textAlign: 'center',
    marginBottom: '20px',
  },

  logo: {
    width: '100%',
    height: '150px',
  },
  companyName: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  date: {
    fontSize: '16px',
    color: '#555',
  },
  table: {
    width: '100%',
    // borderCollapse: 'collapse',
  },
  header: {
    // backgroundColor: '#f4f4f4',
    padding: '0px',
    textAlign: 'left',
    // border: '1px solid #ddd',
  },
  rowLabel: {
    padding: '0px',
    // border: '1px solid #ddd',
  },
  rowAmount: {
    padding: '0px',
    // border: '1px solid #ddd',
    textAlign: 'right',
  },
  mainAccount: {
    padding: '0px',
    // backgroundColor: '#e0e0e0',
    fontWeight: 'bold',
    textAlign: 'left',
    // border: '1px solid #ddd',
  },
  subAccountRow: {
    // backgroundColor: '#f9f9f9',
  },
  subAccountLabel: {
    paddingLeft: '24px', // Indent for sub-accounts
    padding: '0px',
    // border: '1px solid #ddd',
  },
  totalLabel: {
    fontWeight: 'bold',
    padding: '0px',
    // backgroundColor: '#d3d3d3',
    textAlign: 'left',
    // border: '1px solid #ddd',
  },
};

export default BalanceSheet;
